export default interface IRepair {
  id: string;
  barcode: string;
  shiplog: boolean;
}
export const emptyIRepair = (): IRepair => ({
  id: '',
  barcode: '',
  shiplog: false,
});
